module.exports = __webpack_public_path__ + "media/complete.5168b63f.mp3";